import { useEffect, useRef, useState } from 'react';
import { subscribeEvents, type VisionEvent } from '../lib/api';

const MAX_ROWS = 50;

export default function EventTicker() {
  const [events, setEvents] = useState<VisionEvent[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const unsub = subscribeEvents((e) => {
      setEvents((prev) => [e, ...prev].slice(0, MAX_ROWS));
    });
    return unsub;
  }, []);

  return (
    <div style={{
      borderTop: '1px solid var(--grid-line)',
      background: 'var(--background)',
      paddingTop: '1.5rem',
    }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
        <div className="eyebrow">
          <span className="dot dot-pulse" style={{ background: 'var(--orange)' }} />[ event log · live ]
        </div>
        <div className="mono" style={{ fontSize: 10, color: 'var(--muted)' }}>
          {events.length} / {MAX_ROWS}
        </div>
      </div>

      <div
        ref={containerRef}
        className="mono"
        style={{
          fontSize: 12,
          lineHeight: 1.7,
          maxHeight: 280,
          overflowY: 'auto',
          border: '1px solid var(--grid-line)',
          background: '#FAF9F4',
        }}
      >
        {events.length === 0 ? (
          <div style={{ padding: '1rem', color: 'var(--muted)' }}>
            ▸ awaiting first event…
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              {events.map((e) => (
                <tr key={e.id} style={{ borderBottom: '1px dashed var(--grid-line)' }}>
                  <td style={{ padding: '0.4rem 0.75rem', color: 'var(--muted)', whiteSpace: 'nowrap' }}>
                    {fmtTime(e.ts)}
                  </td>
                  <td style={{ padding: '0.4rem 0.5rem', color: 'var(--blue)' }}>
                    {e.camera_id}
                  </td>
                  <td style={{ padding: '0.4rem 0.5rem' }}>
                    {e.event_type}
                  </td>
                  <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: 'var(--muted)' }}>
                    {(e.confidence * 100).toFixed(0)}%
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function fmtTime(ts: number): string {
  const d = new Date(ts);
  return d.toTimeString().slice(0, 8);
}
